// Note: avoid nested routes (eg. /settings/section), as our current route config doesn't work well with react-router's way of doing nested routes

const routes = {
  home: '/',
  loginRedirect: '/login-redirect',
  orgSwitchRedirect: '/org-switch-redirect',
  noOrgsFound: '/no-orgs-found',
  noUserEmail: '/no-user-email',
  invalidInvitation: '/invalid-invitation',

  // --- Side Nav routes
  // Any new routes added here need to be added to appropriate active route lookup: ion/packages/app/src/components/side-nav/index.js
  dashboard: '/dashboard',
  eventMonitoring: '/event-monitoring',

  pipelines: '/pipelines',
  pipelineDetails: '/pipeline-details',
  integrations: '/integrations',
  clusters: '/clusters',

  settings: '/settings',
  auditLog: '/audit-log',
  schemas: '/schema-enforcement',
  schemaLibrary: '/schema-library',
  schemaViolations: '/schema-violations',
  eventSchemaViolations: '/event-schema-violations',
  logOut: '/log-out',

  newIntegration: '/create-integration',
  editPlaybook: '/edit-integration',
  newPipeline: '/create-pipeline',
  connectIntegration: '/connect-integration',
  analyticsJSBuilder: '/analytics-builder',
  analyticsFiles: '/analytics-files',
  bulkDeploy: '/bulk-deploy',
  metatagger: '/metatagger',
};

const scrollTimeout = 600;

export { routes, scrollTimeout };
